// contains the applicant's data (used to keep track of the treasure unlocked)
var applicantData = {
  treasuresObtained: new Set(),
};

export default applicantData;
